import determineOfferFeatureSymbol from 'lib/offer/determineOfferFeatureSymbol'
import type { SearchTileRowInclusion } from '../shared/SearchTileRowInclusionItem'

export function mapPropertyPopularFacilityToAmenity(facility: App.Property.AmenityItem): SearchTileRowInclusion {
  return {
    id: facility.id,
    description: facility.name,
    propertyIconName: facility.iconName,
    symbol: determineOfferFeatureSymbol(facility.name),
  }
}

export function mapPropertyPopularFacilitiesToAmenities(
  facilities: Array<App.Property.AmenityItem>,
): Array<SearchTileRowInclusion> {
  return facilities.map(mapPropertyPopularFacilityToAmenity)
}
